<template>
	<div>
		<div class="xs-12 fs4 fw7 mt6 mb2">
			Since the earlier of the date(s) on which you signed the Information
			Disclosure and Authorization, the Confidential Medical Questionnaire
			and/or the Health History Questionnaire:
		</div>
		<case-form :schema="schema" class="mt6" />
		<case-form :schema="schemaTravel" class="mt6 mb6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			Provide travel pattern over the past 14 days:
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Travel Pattern</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelPast14Days(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="fs4 fw7 lh125 mt6 mb2">
			Provide travel pattern in next 30 days:
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Travel Pattern</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelNext30Days(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaSmoking" class="mt6" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Cigarettes</div>
		<case-form :schema="schemaCigarettes" />
		<case-form :schema="schemaFinancial" class="mt6" />
		<case-form :schema="schemaAviation" class="mt6" />
		<case-form :schema="schemaHazardousActivities" class="mt6" />
		<case-form :schema="schemaInsurance" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: `Have you tested positive for COVID-19?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasTestedPostiveForCovid19`,
					props: {
						suggest: {
							typeIncludes: `hasTestedPostiveForCovid19`
						},
						createOptions: {
							type: `hasTestedPostiveForCovid19`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `In the last 30 days have you, been advised to self-isolate or stay home due to COVID-19 (excluding mandatory government orders to remain at home)?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasBeenAdvisedToIsolateDueToCovid19`,
					props: {
						suggest: {
							typeIncludes: `hasBeenAdvisedToIsolateDueToCovid19`
						},
						createOptions: {
							type: `hasBeenAdvisedToIsolateDueToCovid19`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `In the last 30 days have you, Had a persistent cough, fever or raised temperature, malaise, rhinorrhea (mucus discharge from the nose), sore throat,
gastro-intestinal symptoms such as nausea, vomiting and/or diarrhea?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasCovid19SymptomsInLast30Days`,
					props: {
						suggest: {
							typeIncludes: `hasCovid19SymptomsInLast30Days`
						},
						createOptions: {
							type: `hasCovid19SymptomsInLast30Days`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `In the last 30 days have you, Had any contact with an individual suspected or confirmed to have COVID-19?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasContactWithCovid19PatientInLast30Days`,
					props: {
						suggest: {
							typeIncludes: `hasContactWithCovid19PatientInLast30Days`
						},
						createOptions: {
							type: `hasContactWithCovid19PatientInLast30Days`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `If “Yes” to any of the above, have you made a full recovery and returned to normal activities?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasRecoveredFromCovid19`,
					props: {
						suggest: {
							typeIncludes: `hasRecoveredFromCovid19`
						},
						createOptions: {
							type: `hasRecoveredFromCovid19`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Have you been examined or treated by, or consulted a physician or other practitioner?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasBeenTreatedByPhysicianOrPractitioner`,
					props: {
						suggest: {
							typeIncludes: `hasBeenTreatedByPhysicianOrPractitioner`
						},
						createOptions: {
							type: `hasBeenTreatedByPhysicianOrPractitioner`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Have you had an electrocardiogram, x-ray or other diagnostic test?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasDiagnosticTest`,
					props: {
						suggest: {
							typeIncludes: `hasDiagnosticTest`
						},
						createOptions: {
							type: `hasDiagnosticTest`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Have you used marijuana, cocaine, or any other drug except as prescribed by physician?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasUsedDrugsWithoutPrescription`,
					props: {
						suggest: {
							typeIncludes: `hasUsedDrugsWithoutPrescription`
						},
						createOptions: {
							type: `hasUsedDrugsWithoutPrescription`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Have you been treated or counseled for alcoholism or drug abuse?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasTreatedOrCounseledForAlcoholismOrDrugAbuse`,
					props: {
						suggest: {
							typeIncludes: `hasTreatedOrCounseledForAlcoholismOrDrugAbuse`
						},
						createOptions: {
							type: `hasTreatedOrCounseledForAlcoholismOrDrugAbuse`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Have you been diagnosed or treated by a qualified physician for Acquired Immune Deficiency Syndrome (AIDS), AIDS Related Complex (ARC) or any other disorders of the immune system?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasImmuneSystemDisorder`,
					props: {
						suggest: {
							typeIncludes: `hasImmuneSystemDisorder`
						},
						createOptions: {
							type: `hasImmuneSystemDisorder`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Are you aware of any symptom or complaint, regarding your health, for which you have not yet consulted a physician or received treatment?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasUnconsultedSymptoms`,
					props: {
						suggest: {
							typeIncludes: `hasUnconsultedSymptoms`
						},
						createOptions: {
							type: `hasUnconsultedSymptoms`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Other than for conditions already disclosed, has a doctor recommended any tests or referrals that have not yet been completed,
or are you currently awaiting test results?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-isWaitingForTestResult`,
					props: {
						suggest: {
							typeIncludes: `isWaitingForTestResult`
						},
						createOptions: {
							type: `isWaitingForTestResult`,
							dataType: "boolean"
						}
					}
				},
				{
					label:
						"For all yes answers above, please provide full details. Details should include dates, date of onset of symptoms, diagnoses, duration, and name and address of attending physician and medical facility:",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-supplementalInformationMedicalHistoryAdditionalDetails`,
					props: {
						suggest: {
							typeIncludes: `supplementalInformationMedicalHistoryAdditionalDetails`
						},
						createOptions: {
							type: `supplementalInformationMedicalHistoryAdditionalDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTravel() {
			return [
				{
					label: `Have you travelled over the past 14 days?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasTravelledPast14Days`,
					props: {
						suggest: {
							typeIncludes: `hasTravelledPast14Days`
						},
						createOptions: {
							type: `hasTravelledPast14Days`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Do you intend to travel over the next 30 days?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-willTravelInNext30Days`,
					props: {
						suggest: {
							typeIncludes: `willTravelInNext30Days`
						},
						createOptions: {
							type: `willTravelInNext30Days`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaFinancial() {
			return [
				{
					label: "Has your work or financial status changed?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasWorkOrFinancialStatusChanged`,
					props: {
						suggest: {
							typeIncludes: `hasWorkOrFinancialStatusChanged`
						},
						createOptions: {
							type: `hasWorkOrFinancialStatusChanged`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, please explain",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-workOrFinancialStatusChangeDetails`,
					props: {
						suggest: {
							typeIncludes: `workOrFinancialStatusChangeDetails`
						},
						createOptions: {
							type: `workOrFinancialStatusChangeDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaAviation() {
			return [
				{
					label:
						"Has your participation in aviation activity (other than as a passenger on scheduled commercial airlines) changed?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasAviationActivityChanged`,
					props: {
						suggest: {
							typeIncludes: `hasAviationActivityChanged`
						},
						createOptions: {
							type: `hasAviationActivityChanged`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, please describe",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-aviationActivityChangeDetails`,
					props: {
						suggest: {
							typeIncludes: `aviationActivityChangeDetails`
						},
						createOptions: {
							type: `aviationActivityChangeDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaHazardousActivities() {
			return [
				{
					label:
						"Has your participation in any avocation (hazardous sporting activies) changed?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasAvocationParticipationChanged`,
					props: {
						suggest: {
							typeIncludes: `hasAvocationParticipationChanged`
						},
						createOptions: {
							type: `hasAvocationParticipationChanged`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, please describe",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-avocationParticipationChangeDetails`,
					props: {
						suggest: {
							typeIncludes: `avocationParticipationChangeDetails`
						},
						createOptions: {
							type: `avocationParticipationChangeDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaInsurance() {
			return [
				{
					label:
						"Has any application for, or reinstatement of, life or health insurance been refused or been accepted under special terms?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasInsuranceApplicationRejectedUnderSpecialTerms`,
					props: {
						suggest: {
							typeIncludes: `hasInsuranceApplicationRejectedUnderSpecialTerms`
						},
						createOptions: {
							type: `hasInsuranceApplicationRejectedUnderSpecialTerms`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, state company name and reason:",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-insuranceApplicationRejectedDetails`,
					props: {
						suggest: {
							typeIncludes: `insuranceApplicationRejectedDetails`
						},
						createOptions: {
							type: `insuranceApplicationRejectedDetails`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Has your life insurance in-force coverage changed since you completed the Information Disclosure and Authorization form?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasLifeInsuranceInForceChanged`,
					props: {
						suggest: {
							typeIncludes: `hasLifeInsuranceInForceChanged`
						},
						createOptions: {
							type: `hasLifeInsuranceInForceChanged`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, please explain:",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-lifeInsuranceInForceChangeDetails`,
					props: {
						suggest: {
							typeIncludes: `lifeInsuranceInForceChangeDetails`
						},
						createOptions: {
							type: `lifeInsuranceInForceChangeDetails`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Do you have any applications pending for life insurance coverage with other carriers?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasPendingApplicationWithOtherCarriers`,
					props: {
						suggest: {
							typeIncludes: `hasPendingApplicationWithOtherCarriers`
						},
						createOptions: {
							type: `hasPendingApplicationWithOtherCarriers`,
							dataType: "boolean"
						}
					}
				},
				{
					label:
						"If yes, please provide details including total amount applied for:",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-pendingApplicationDetails`,
					props: {
						suggest: {
							typeIncludes: `pendingApplicationDetails`
						},
						createOptions: {
							type: `pendingApplicationDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Additional Information",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-additionalInformation`,
					props: {
						suggest: {
							typeIncludes: `additionalInformation`
						},
						createOptions: {
							type: `additionalInformation`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaSmoking() {
			return [
				{
					label:
						"Have you ever used tobacco or nicotine products in any form (including cigarettes, cigars, cigarillos, pipe, chewing tobacco, nicotine patches or gum)?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-useTobaccoOrNicotineProduct`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProduct`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProduct`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaCigarettes() {
			return [
				{
					label: `Product`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteProductUsed`,
					props: {
						suggest: {
							typeIncludes: `cigaretteProductUsed`
						},
						createOptions: {
							type: `cigaretteProductUsed`,
							dataType: "string"
						}
					}
				},
				{
					label: `Number per day`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteNumberPerDay`,
					props: {
						suggest: {
							typeIncludes: `cigaretteNumberPerDay`
						},
						createOptions: {
							type: `cigaretteNumberPerDay`,
							dataType: "number"
						}
					}
				},
				{
					label: `Initials`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteInitials`,
					props: {
						suggest: {
							typeIncludes: `cigaretteInitials`
						},
						createOptions: {
							type: `cigaretteInitials`,
							dataType: "string"
						}
					}
				},
				{
					label: `Did you previously use tobacco products, but have now stopped?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-smokeCigaretteInPast`,
					props: {
						suggest: {
							typeIncludes: `smokeCigaretteInPast`
						},
						createOptions: {
							type: `smokeCigaretteInPast`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Date Stopped`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteDateStoppedUse`,
					props: {
						suggest: {
							typeIncludes: `cigaretteDateStoppedUse`
						},
						createOptions: {
							type: `cigaretteDateStoppedUse`,
							dataType: "date"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaTravelPast14Days(i) {
			return [
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCountry${i}`
						},
						createOptions: {
							type: `past14DaysCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysCity${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCity${i}`
						},
						createOptions: {
							type: `past14DaysCity${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Arrival Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysArrivalDate${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysArrivalDate${i}`
						},
						createOptions: {
							type: `past14DaysArrivalDate${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Departure Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysDepartureDate${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysDepartureDate${i}`
						},
						createOptions: {
							type: `past14DaysDepartureDate${i}`,
							dataType: "date"
						}
					}
				}
			]
		},

		schemaTravelNext30Days(i) {
			return [
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `next30DaysCountry${i}`
						},
						createOptions: {
							type: `next30DaysCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysCity${i}`,
					props: {
						suggest: {
							typeIncludes: `next30DaysCity${i}`
						},
						createOptions: {
							type: `next30DaysCity${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Arrival Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysArrivalDate${i}`,
					props: {
						suggest: {
							typeIncludes: `next30DaysArrivalDate${i}`
						},
						createOptions: {
							type: `next30DaysArrivalDate${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Departure Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysDepartureDate${i}`,
					props: {
						suggest: {
							typeIncludes: `next30DaysDepartureDate${i}`
						},
						createOptions: {
							type: `next30DaysDepartureDate${i}`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
